export default "__VITE_ASSET__CmUghAHJ__"